import { IAllowedApproval } from "amnPos/ticket/Ticket";
import { OrderType } from "models/common-props/TransactionTypes";
import { PaymentMethodType } from "models/PaymentModel";
import { NIL } from "uuid";
export enum ExternalOperationsRelatedToType {
  None = 0,
  Ticket = 1,
  Order = 2,
  Driver = 3,
  Trip = 4,
}
export enum ExternalOperationType {
  Balance = 0,
  Debit = 1, //قبض من زبون
  Credit = 2, //دفعة لزبون
  PayToCentralCash = 3, // دفع للصندوق
  Expense = 4,
  Income = 6,
  Cash = 7,
  OrderDownpayment = 8,
  Downpayment = 9,
  DriverPayment = 10,
  SettlementDriverPayment = 11,
  RemainingDriverPayment = 12,
  DriverCommission = 13,
  CloseShiftDifferences = 14,
  ReceiveFromCentralCash = 15,
  None = -1,
}

export enum ExternalOperationGenerateState {
  Opened = 0, //عملية خارجية متولدة من فتح الجلسة
  Closed = 1, //عملية خارجية متولدة من إقفال الجلسة
  None = 2, //عملية خارجية مضافة يدوياً
  OrderDownpayment = 3, //عملية خارجية متولدة استلام أو إعادة دفعة اولى
  DriverCommission = 4, //عملية خارجية متولدة نتيجة تسليم  دفعة سائق
}

export enum ExternalOperationState {
  Added = 0,
  Canceled = 1,
  Deleted = 2,
}
export interface IExternalOperationsList {
  id: string;
  number: number;
  client: string;
  employeeName: string;
  type: ExternalOperationType;
  generateState: ExternalOperationGenerateState;
  isPayment: boolean;
  description?: string;
  exchangeRate: number;
  amount: number;
  currencySympol: string;
  centralBoxReceiptId: string;
  ticketOrderType?: OrderType;
  ticketNumber?: number;
  orderTripNumber?: number;
  driver?: string;
  passingDriverName?: string;
  bankCard: string;
  verificationCode: string;
  allowedApprovals: IAllowedApproval[];
}
export interface IExternalOperation {
  id: string;
  number: number;
  clientId: string;
  client?: any;
  description?: string;
  type: ExternalOperationType | string;
  shiftId: string;
  externalOperationPayments: IExternalOperationPayment[];
  isPayment?: boolean;
  allowedApprovals: IAllowedApproval[];
}

export const EmptyExternalOperation: IExternalOperation = {
  id: NIL,
  number: 0,
  clientId: NIL,
  client: "",
  description: "",
  type: "",
  shiftId: NIL,
  externalOperationPayments: [],
  allowedApprovals: [],
};

export interface IExternalOperationPayment {
  id: string;
  ExternalOperationId: string;
  payType: PaymentMethodType;
  exchangeRate: number;
  amount: number;
  currencyId: string;
  currencyName?: string;
  bankCardId?: string;
  verificationCode?: string;
}

export const EmptyExternalOperationPayment: IExternalOperationPayment = {
  id: NIL,
  ExternalOperationId: NIL,
  payType: PaymentMethodType.Currency,
  exchangeRate: 0,
  amount: 0,
  currencyId: NIL,
};
